"use client";

import { c as _c } from "react/compiler-runtime";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import { usePathname } from "next/navigation";
import type { NavItemEntry } from "@/lib/contentful/navItem";
import type { PageCrumb } from "@/lib/contentful/pathIndex";
import { PageBreadcrumbView } from "./PageBreadcrumbView";
interface Props {
  chain?: PageCrumb[];
  breadcrumbsStructure?: unknown;
  navMenu: NavItemEntry[];
}
export function PageBreadcrumbClient(t0) {
  const $ = _c(4);
  const {
    chain,
    breadcrumbsStructure,
    navMenu
  } = t0;
  const pathname = usePathname();
  const liveNavMenu = useContentfulLiveUpdates(navMenu);
  if (pathname === "/") {
    return null;
  }
  let t1;
  if ($[0] !== breadcrumbsStructure || $[1] !== chain || $[2] !== liveNavMenu) {
    t1 = <PageBreadcrumbView chain={chain} breadcrumbsStructure={breadcrumbsStructure} navMenu={liveNavMenu} />;
    $[0] = breadcrumbsStructure;
    $[1] = chain;
    $[2] = liveNavMenu;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}